import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Typography,
  TextField,
  Checkbox,
  SelectionControlLabel
} from '@one-thd/sui-atomic-components';
import {
  unsubscribeFromAllSmsSubscriptions,
} from '../../common/sharedFunctions';
import {
  formatPhone,
  PhoneFieldFormatter,
  phoneValidator
} from '../PhoneFieldFormatter/PhoneFieldFormatter';
import constants from '../../constants/constants';

export const enterPhoneText = 'Enter your phone number to unsubscribe from all future text message promotions '
  + 'from The Home Depot. Unsubscribing from all future text message '
  + 'promotions will also add you to The Home Depot\'s Do Not Call list. To continue, please check the box below.';
export const confirmText = 'You have requested to unsubscribe the phone number below from all future text message '
  + 'message promotions from The Home Depot. To continue, please check the box below.';

export const OptOutOfAllModal = ({
  handleClose,
  handleSuccess,
  handleError,
  searchedPhone
}) => {
  const searched = !!searchedPhone;
  const [optOutOfComm, setOptOutOfComm] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(searchedPhone);

  const handleDoNotCallClick = () => {
    unsubscribeFromAllSmsSubscriptions(
      phoneNumber,
      (response) => {
        handleSuccess(phoneNumber, response);
      },
      (err) => {
        handleError(err);
      }
    );
  };

  const isEnabledDisabled = () => {
    return optOutOfComm && phoneValidator(phoneNumber);
  };

  return (
    <Modal open onClose={handleClose}>
      <ModalHeader onClose={handleClose}>Please Confirm Your Unsubscribe Request</ModalHeader>
      <ModalBody>
        <div className="sui-grid sui-gap-8 flex flex-col space-y-4 ...">
          <div>
            <Typography variant="body-sm" weight="base">
              {searched ? confirmText : enterPhoneText }
            </Typography>
          </div>
          <div className="sui-w-72 sui-max-w-full">
            <Typography>
              {searchedPhone ? (
                <TextField
                  id="phone"
                  defaultValue={formatPhone(phoneNumber)}
                  value={formatPhone(phoneNumber)}
                  label="Phone Number"
                  disabled
                />
              ) : (
                <PhoneFieldFormatter
                  callback={setPhoneNumber}
                  value={formatPhone(phoneNumber)}
                  name="phone-unsub"
                />
              )}
            </Typography>
          </div>
          <div>
            <Typography variant="body-xs">
              <SelectionControlLabel value="optOut" label={constants.DO_NOT_WANT_SMS}>
                <Checkbox
                  formName="receiveSmsComm"
                  aria-label="receiveSmsComm"
                  id="receiveSmsComm"
                  onChange={() => setOptOutOfComm(!optOutOfComm)}
                  checked={optOutOfComm}
                  value={optOutOfComm + ''}
                />
              </SelectionControlLabel>
            </Typography>
            <br />
            <div className="sui-mx-6">
              <Typography variant="body-xs">
                {constants.TRANSACTIONAL_COMMUNICATION_DISCLAIMER}
              </Typography>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter position="end">
        <Button aria-label="doNotCallButton" onClick={handleDoNotCallClick} disabled={!isEnabledDisabled()}>
          Continue
        </Button>
      </ModalFooter>
    </Modal>
  );
};

OptOutOfAllModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleSuccess: PropTypes.func.isRequired,
  handleError: PropTypes.func,
  searchedPhone: PropTypes.string,
};

OptOutOfAllModal.defaultProps = {
  handleError: () => {},
  searchedPhone: '',
};
